import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared.module';
import { ConversationalNotificationComponent } from './conversational-notification/conversational-notification.component';
import { InformationalNotificationComponent } from './informational-notification/informational-notification.component';
import { NotificationsCounterComponent } from './notifications-counter/notifications-counter.component';
import { NotificationsDropdownComponent } from './notifications-dropdown/notifications-dropdown.component';

@NgModule({
  declarations: [
    NotificationsCounterComponent,
    NotificationsDropdownComponent,
    InformationalNotificationComponent,
    ConversationalNotificationComponent,
  ],
  exports: [NotificationsDropdownComponent],
  imports: [CommonModule, NgbDropdownModule, RouterModule, SharedModule],
})
export class EventNotificationsModule {}
